import React, { useState } from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/vendor-create-screen.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/VendorForm';
import { routes } from '../../../../../../navigation';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';

export interface StateProps {
    inProgress: boolean;
}

export interface DispatchProps {}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const VendorCreateScreen: React.FunctionComponent<Props> = (props) => {
    const [files, setFiles] = useState([]);

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'VENDORS', path: routes.VENDORS_LIST },
                    { name: `ADD NEW`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                {props.inProgress ? <Loader /> : null}
                <Form
                    files={files}
                    setFiles={setFiles}
                    removeFile={(id) => {
                        files.splice(id, 1);
                        setFiles([...files]);
                    }}
                    initialValues={{}}
                />
            </div>
        </AdminLayout>
    );
};

export default VendorCreateScreen;
